import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { homePageFr } from "./french/homePageFr";
import { paymentModeFr } from "./french/paymentModeFr";
import { roleFr } from "./french/roleFr";
import { loginFr } from "./french/loginFr";
import { userFr } from "./french/userFr";
import { userAr } from "./arabic/userAr";
import { loginAr } from "./arabic/loginAr";
import { homePageAr } from "./arabic/homePageAr";
import { paymentModeAr } from "./arabic/paymentModeAr";
import { roleAr } from "./arabic/roleAr";
import { supplierFr } from "./french/supplierFr";
import { saleFr } from "./french/saleFr";
import { purchaseFr } from "./french/purchaseFr";
import { productFr } from "./french/productFr";
import { expenseFr } from "./french/expenseFr";
import { clientFr } from "./french/ClientFr";
import { supplierAr } from "./arabic/supplierAr";
import { saleAr } from "./arabic/saleAr";
import { purchaseAr } from "./arabic/purchaseAr";
import { productAr } from "./arabic/productAr";
import { expenseAr } from "./arabic/expenseAr";
import { clientAr } from "./arabic/ClientAr";
import { PaymentAr } from "./arabic/Paiements";
import { PaymentFr } from "./french/PaymentFr";
import { CategoryAr } from "./arabic/CategoryAr";
import { CategoryFr } from "./french/CategoryFr";
import { PermissionAr } from "./arabic/PermissionAr";
import { PermissionFr } from "./french/PermissionFr";
import { FrontendAr } from "./arabic/FrontendAr";
import { FrontendFr } from "./french/frontendFr";

const resources = {
  ar: {
    translation: Object.assign(userAr, supplierAr, saleAr, roleAr, purchaseAr, productAr, paymentModeAr, loginAr, homePageAr, expenseAr, clientAr, PaymentAr, CategoryAr, PermissionAr, FrontendAr)
  },
  fr: {
    translation: Object.assign(userFr, supplierFr, saleFr, roleFr, purchaseFr, productFr, paymentModeFr, loginFr, homePageFr, expenseFr, clientFr, PaymentFr, CategoryFr, PermissionFr, FrontendFr)
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("lang") ?? "fr",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;